import cc from "classcat";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { currentPathnameState } from "../../states/NavigationStates";

const HeaderNavigationItem = ({ href, target = "_self", title = "", children, ...props }) => {
	const currentPath = useRecoilValue(currentPathnameState);

	const isCurrent = useMemo(() => {
		const cleanCurrent = currentPath.replace(/^\/|\/$/g, "");
		const cleanHref = href.replace(/^\/|\/$/g, "");

		return cleanCurrent.includes(cleanHref);
	}, [href, currentPath]);

	return (
		<li className="nav-list-item" {...props}>
			<a className="nav-link px-4 py-2 d-block" target={target} title={title} href={href}>
				<span className="nav-link-item">
					<span
						className={cc([
							"d-inline-block align-middle",
							{
								"text-underline": isCurrent,
							},
						])}
					>
						{children}
					</span>
				</span>
			</a>
		</li>
	);
};

export default HeaderNavigationItem;
